import * as S from './PoliciesModalContent.styles';
import BrandModalHeader from '../../../../../shared/components/BrandModalHeader';
import RoundedCheckboxIcon from '../../../../Icons/RoundedCheckbox';

const PoliciesModalContent = ({
  cancellationPolicy = [],
  hotelsPolicy = [],
  policyError = false,
  showLoader = false,
}) => {
  return (
    <>
      {(!!cancellationPolicy.length || !!hotelsPolicy.length) && (
        <S.PolicyContentContainer>
          {!!cancellationPolicy.length && (
            <>
              <BrandModalHeader>Cancellation Policy</BrandModalHeader>

              <S.CancellationPolicyList>
                {cancellationPolicy.map(item => (
                  <S.CancellationPolicyListItem key={item}>
                    <RoundedCheckboxIcon />
                    <S.CancellationItemText>{item}</S.CancellationItemText>
                  </S.CancellationPolicyListItem>
                ))}
              </S.CancellationPolicyList>
            </>
          )}
          {!!hotelsPolicy.length && (
            <>
              <BrandModalHeader>Hotel Policy</BrandModalHeader>

              <S.CancellationPolicyList>
                {hotelsPolicy.map(item => (
                  <S.CancellationPolicyListItem key={item}>
                    <RoundedCheckboxIcon />
                    <S.CancellationItemText>{item}</S.CancellationItemText>
                  </S.CancellationPolicyListItem>
                ))}
              </S.CancellationPolicyList>
            </>
          )}
        </S.PolicyContentContainer>
      )}

      {policyError && (
        <S.CancellationPolicyLoaderContainer>
          <S.CancellationPolicyErrorText>
            Something Went Wrong While Loading Cancellation Policy
          </S.CancellationPolicyErrorText>
        </S.CancellationPolicyLoaderContainer>
      )}

      {showLoader && (
        <S.CancellationPolicyLoaderContainer>
          <S.CancellationPolicyListLoaderSmallItem></S.CancellationPolicyListLoaderSmallItem>
          <S.CancellationPolicyListLoaderLargeItem></S.CancellationPolicyListLoaderLargeItem>
          <S.CancellationPolicyListLoaderSmallItem></S.CancellationPolicyListLoaderSmallItem>
          <S.CancellationPolicyListLoaderLargeItem></S.CancellationPolicyListLoaderLargeItem>
        </S.CancellationPolicyLoaderContainer>
      )}
    </>
  );
};

export default PoliciesModalContent;
